<div class="request">
    <div class="head">
        <div class="back" (click)="back()" ></div>
        <span (click)="send()">发送</span>
    </div>
    <div class="content">
        <textarea name="question-textarea" maxlength="200" (blur)="textareaBlur()" (focus)="textareaFocus()" ></textarea>
        <div class="questionnaire-testarea-placeholder" *ngIf="selectedTag === ''&&isShowPlaceholder" (click)="closePlaceholder()">{{placeholder}}</div>
    </div>
    <!--提示框-->
    <app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="destext" [cancelText]="''" [sureText]="''" ></app-com-tip>
</div>


// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-request/home-work-request.component.html